<template>
  <div class="i-how-it-works">
    <div class="top">
      <div class="header">How it <strong>Works</strong></div>
      Get started in minutes and begin your transformation today
    </div>
    <div class="bottom">
      <div class="line"></div>
      <div
        v-for="(detail, i) in DETAILS"
        :key="i"
        class="detail"
      >
        <div class="image">
          <div class="number">{{ i + 1 }}</div>
          <img :src="detail.image" />
        </div>
        <div class="title">{{ detail.title }}</div>
        <div class="summary">{{ detail.summary }}</div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { GlobalFunctions } from "@/helpers/globalFunctions"

// ASSETS
import Image1 from "@/assets/images/cb-works1.svg"
import Image2 from "@/assets/images/cb-works2.svg"
import Image3 from "@/assets/images/cb-works3.svg"
import Image4 from "@/assets/images/cb-works4.svg"

// EMITS
const emit = defineEmits(["close", "claim-resume-builder"])

// CONSTANTS
const DETAILS = [
  {
    image: Image1,
    title: "Choose Your Plan",
    summary: "Select Core or Accelerated coaching based on your career goals"
  },
  {
    image: Image2,
    title: "Pay Your Way",
    summary: "Pay in full or split into 4 easy payments with Klarna — 0% interest, no credit check"
  },
  {
    image: Image3,
    title: "Start Immediately",
    summary: "Book your first session within 25 hours of signup"
  },
  {
    image: Image4,
    title: "Transform Your Career",
    summary: `4 full months to land your dream job during ${GlobalFunctions.setToLastDateTimeOfMonth().toLocaleString("default", { month: "long" })}'s hiring surge`
  }
]
</script>

<style scoped lang="scss">
.i-how-it-works {
  @include flex(column, center, center, $gap: 30px);

  margin: 44px 0;

  @media screen and (min-width: $breakpoint-md) {
    gap: 50px;
    margin: 64px 0;
  }

  .top {
    @include flex(column, center, center, $gap: 12px);
    @include text-lg;

    text-align: center;
    font-weight: 400;

    .header {
      @include display-lg;
    }
  }

  .bottom {
    @include flex(column, start, center, $gap: 32px);

    position: relative;
    text-align: center;

    @media screen and (min-width: $breakpoint-sm) {
      @include grid(
        $cols: repeat(2, minmax(200px, 232px)),
        $rows: repeat(2, auto),
        $align-items: stretch,
        $gap: 28px 18px
      );
    }

    @media screen and (min-width: $breakpoint-md) {
      gap: 44px;
    }

    @media screen and (min-width: $breakpoint-lg) {
      @include grid($cols: repeat(4, minmax(200px, 257.5px)), $rows: 1fr, $align-items: stretch);
    }

    .line {
      position: absolute;

      @media screen and (min-width: $breakpoint-lg) {
        display: block;
        top: 43.5px;
        left: 50%;
        transform: translateX(-50%);
        width: 75%;
        height: 2px;
        background-color: $amethyst400;
      }
    }

    .detail {
      @include flex(column, start, center, $gap: 8px);

      .image {
        position: relative;
        background-color: $white;
        border-radius: 20px;

        .number {
          @include flex(row, center, center);
          @include border-radius-rounded;
          @include text-xs;

          right: 0;
          top: 0;
          transform: translate(30%, -30%);
          position: absolute;
          width: 24px;
          height: 24px;
          font-weight: 700;
          color: $white;
          background: linear-gradient(180deg, #4a9dff 0%, #be4fff 100%);
        }
      }

      .title {
        @include text-lg;

        font-weight: 700;
        margin-top: 10px;
      }

      .summary {
        @include text-sm;

        font-weight: 400;
        max-width: 232px;
      }
    }
  }
}
</style>
